import { Heading, Text, Image } from '@bq/web-components';
import styles from './AboutSection.module.css';

export function AboutSection() {
  return (
    <section data-crd-id="r4.bq-about-section" data-crd-layer="r4" className={styles.section} id="about">
      <div className={styles.container}>
        <div className={styles.content}>
          <Heading level={3} as={3} color="s500">
            Your Project Sherpas
          </Heading>
          <Heading level={2} color="n000">
            About Us
          </Heading>
          <div className={styles.bodyWrap}>
            <Text size="r2" color="n000">
              We are product developers like you. Our goals are to help you like
              your tech sherpa, guide you with an AI sensei where we can, and to
              help continue to ascend in your ninja-like dev super powers!
              Everything we do is, and will be, focused on helping you achieve
              your product development goals.
            </Text>
            <Text size="r2" color="n000">
              We&apos;re a new kind of AI company. We see ourselves as product
              developers too, whether that is a product manager, a developer, QA,
              devOps, project manager or scrum master - nothing gets released
              without us wanting to use it ourselves.
            </Text>
          </div>
          <Image
            src="/assets/images/logo-white.png"
            alt="BlueQueue"
            width={70}
            className={styles.logo}
          />
        </div>
      </div>
    </section>
  );
}
